// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"026a222d","453":"243d4117"}[chunkId] + ".chunk.js";
};